const squiggles = {
  callback: (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const target = entry.target
        observer.unobserve(target)

        target.classList.add('squiggle')
        setTimeout(() => {
          target.addEventListener('mouseenter', () => {
            target.classList.remove('hoverOut')
            target.classList.add('hover')
          })
          target.addEventListener('mouseleave', () => {
            target.classList.remove('hover')
            target.classList.add('hoverOut')
          })
        }, 1000)
      }
    })
  },
  init: () => {
    const observer = new IntersectionObserver(squiggles.callback, {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    })

    document.querySelectorAll('u').forEach(target => {
      observer.observe(target)
    })
  }
}

export default squiggles
